import _get from 'lodash/get';
import {
  AiUsageByUserSortInputObject,
  SortDirectionEnum,
} from 'graphql-common';
import { GetUrlParams, OrderingParams } from '@lib/enums/urls';

// Table ordering state carries the column id, which matches the sort key the
// query expects (see getAiUsageTableColumns).
export default function getAiUsageSorts(
  orderingParams: OrderingParams,
): AiUsageByUserSortInputObject | undefined {
  const field = _get(orderingParams, GetUrlParams.OrderingField);
  const direction = _get(orderingParams, GetUrlParams.OrderingDirection);
  if (!field || !direction) return undefined;
  return {
    [field]: direction as SortDirectionEnum,
  } as AiUsageByUserSortInputObject;
}
